<section class="spriced-filter-dialog">
  <header class="spriced-filter-header">
    <h2>Filter</h2>
  </header>

  <mat-dialog-content class="spriced-filter-content">
    <ng-template #ruleSetTemplate let-formGroup="formGroup" let-parentGroup="parentGroup" let-index="index">
      <section class="ruleset" [class.ruleset--nested]="parentGroup" [formGroup]="formGroup">
        <div class="ruleset-header">
          <div class="ruleset-condition">
            <mat-icon class="ruleset-chevron">keyboard_arrow_down</mat-icon>
            <mat-button-toggle-group formControlName="condition" aria-label="Condition">
              <mat-button-toggle value="AND">And</mat-button-toggle>
              <mat-button-toggle value="OR">Or</mat-button-toggle>
            </mat-button-toggle-group>
          </div>

          <div class="ruleset-actions">
            <button mat-flat-button class="action-button" type="button" (click)="addRule(formGroup)">Rule</button>
            <button mat-flat-button class="action-button" type="button" (click)="addRuleSet(formGroup)">Rule set</button>
            <button *ngIf="parentGroup"
                    mat-icon-button
                    class="delete-button"
                    type="button"
                    aria-label="Delete rule set"
                    (click)="removeRule(parentGroup, index)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <div *ngIf="getRules(formGroup).controls.length === 0 && formGroup.touched" class="validation-error">
          Please select filter criteria.
        </div>

        <div formArrayName="rules" class="rules-container">
          <div *ngFor="let control of getRules(formGroup).controls; let i = index" class="rule-or-ruleset-container">
            <ng-container [formGroupName]="i">
              <div *ngIf="!isRuleSet(control)" class="rule">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-select formControlName="field"
                              placeholder="Attribute"
                              (selectionChange)="onFieldSelectionChange(control)">
                    <mat-option>
                      <ngx-mat-select-search
                        [formControl]="getRuleFieldSearchControl(control)"
                        placeholderLabel="Search attribute"
                        noEntriesFoundLabel="No matching attributes">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let field of getFilteredFields(control)" [value]="field.value">
                      {{ field.viewValue }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="control.get('field')?.hasError('required')">Attribute is required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-select formControlName="operator" placeholder="Operator">
                    <mat-option>
                      <ngx-mat-select-search
                        [formControl]="getRuleOperatorSearchControl(control)"
                        placeholderLabel="Search operator"
                        noEntriesFoundLabel="No matching operators">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let op of getFilteredOperators(control)" [value]="op.value">
                      {{ op.viewValue }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="control.get('operator')?.hasError('required')">Operator is required</mat-error>
                </mat-form-field>

                <ng-container *ngIf="shouldShowValueField(control)">
                  <ng-container *ngIf="isDomainAttribute(control.get('field')?.value); else freeFormValue">
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                      <mat-select formControlName="value"
                                  placeholder="Value"
                                  [disabled]="isDomainAttributeLoading(control.get('field')?.value)">
                        <mat-option>
                          <ngx-mat-select-search
                            [formControl]="getRuleValueSearchControl(control)"
                            placeholderLabel="Search value"
                            noEntriesFoundLabel="No matching values">
                          </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngIf="isDomainAttributeLoading(control.get('field')?.value)" disabled>
                          Loading...
                        </mat-option>
                        <mat-option *ngFor="let option of getFilteredDomainAttributeOptions(control)" [value]="option.value">
                          {{ option.label }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="control.get('value')?.hasError('required')">Value is required</mat-error>
                    </mat-form-field>
                  </ng-container>
                </ng-container>

                <ng-template #freeFormValue>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <input matInput formControlName="value" placeholder="Value">
                    <mat-error *ngIf="control.get('value')?.hasError('required')">Value is required</mat-error>
                  </mat-form-field>
                </ng-template>

                <button mat-icon-button
                        class="delete-button"
                        type="button"
                        aria-label="Delete rule"
                        (click)="removeRule(formGroup, i)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>

              <ng-container *ngIf="isRuleSet(control)">
                <ng-container *ngTemplateOutlet="ruleSetTemplate; context: { formGroup: control, parentGroup: formGroup, index: i }"></ng-container>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </section>
    </ng-template>

    <ng-container *ngTemplateOutlet="ruleSetTemplate; context: { formGroup: queryForm, parentGroup: null, index: -1 }"></ng-container>
  </mat-dialog-content>

  <mat-dialog-actions class="spriced-filter-footer" align="end">
    <button mat-flat-button class="cancel-button" type="button" (click)="onCancel()">Cancel</button>
    <button mat-flat-button class="save-button" type="button" (click)="onApply()" [disabled]="queryForm.invalid">Save</button>
    <button mat-flat-button class="apply-button" type="button" (click)="onApply()" [disabled]="queryForm.invalid">Apply</button>
  </mat-dialog-actions>
</section>
